import React, { useEffect, useState } from "react";

// Kakao 객체 타입 선언
declare global {
  interface Window {
    Kakao: any;
  }
}

interface NavigationLinksProps {
  location: {
    latitude: number;
    longitude: number;
    name: string;
  };
}

const NavigationLinks: React.FC<NavigationLinksProps> = ({ location }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // 카카오 SDK 초기화
  useEffect(() => {
    if (window.Kakao && !window.Kakao.isInitialized()) {
      window.Kakao.init("ce21a9a0584e402f42f6e9bc767aa4b9");
    }
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleTmapClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isMobile) {
      e.preventDefault();
      alert("모바일에서 확인 가능합니다.");
    }
  };

  // 네이버 지도 내비게이션 실행 함수
  const handleNaverMapClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (isMobile) {
      // 모바일에서는 네이버 지도 앱으로 직접 내비게이션 시작
      const naverNaviUrl = `nmap://navigation?dlat=${location.latitude}&dlng=${
        location.longitude
      }&dname=${encodeURIComponent(location.name)}&appname=wedding`;

      try {
        window.location.href = naverNaviUrl;

        // 앱이 설치되지 않은 경우를 대비해 잠시 후 웹사이트로 이동
        setTimeout(() => {
          window.open(
            `https://map.naver.com/v5/directions/-/-/${location.latitude},${
              location.longitude
            }/${encodeURIComponent(location.name)}`,
            "_blank"
          );
        }, 1000);
      } catch (error) {
        // 오류 발생 시 웹사이트로 이동
        window.open(
          `https://map.naver.com/v5/directions/-/-/${location.latitude},${
            location.longitude
          }/${encodeURIComponent(location.name)}`,
          "_blank"
        );
      }
    } else {
      // PC에서는 네이버 지도 웹사이트로 이동
      window.open(
        `https://map.naver.com/v5/directions/-/-/${location.latitude},${
          location.longitude
        }/${encodeURIComponent(location.name)}`,
        "_blank"
      );
    }
  };

  // 카카오내비 실행 함수
  const handleKakaoNaviClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // 좌표값 검증 및 변환
    const longitude = Number(location.longitude);
    const latitude = Number(location.latitude);

    // 좌표값이 유효한지 확인
    if (isNaN(longitude) || isNaN(latitude) || !location.name) {
      console.error("유효하지 않은 좌표값:", {
        longitude,
        latitude,
        name: location.name,
      });
      // 좌표값이 유효하지 않으면 웹 링크로 이동
      window.open(
        `https://map.kakao.com/link/to/${encodeURIComponent(location.name)},${
          location.latitude
        },${location.longitude}`,
        "_blank"
      );
      return;
    }

    if (window.Kakao && window.Kakao.Navi) {
      try {
        window.Kakao.Navi.start({
          name: location.name,
          x: longitude,
          y: latitude,
          coordType: "wgs84",
        });
      } catch (error) {
        console.error("카카오내비 실행 오류:", error);
        // 카카오내비 앱이 없거나 오류가 발생한 경우 웹 링크로 이동
        window.open(
          `https://map.kakao.com/link/to/${encodeURIComponent(
            location.name
          )},${latitude},${longitude}`,
          "_blank"
        );
      }
    } else {
      // SDK가 로드되지 않은 경우 웹 링크로 이동
      window.open(
        `https://map.kakao.com/link/to/${encodeURIComponent(
          location.name
        )},${latitude},${longitude}`,
        "_blank"
      );
    }
  };

  const { latitude, longitude, name } = location;

  // 모바일용 앱 스킴 URL (T맵용)
  const mobileUrls = {
    tmap: `tmap://?rGoName=${encodeURIComponent(
      name
    )}&rGoX=${longitude}&rGoY=${latitude}`,
  };

  // PC용 웹 URL (T맵용)
  const webUrls = {
    tmap: `https://apis.openapi.sk.com/tmap/app/routes?appKey=l7xxf0c0c0c0c0c0c0c0c0c0c0c0c0c0c0c0&name=${encodeURIComponent(
      name
    )}&lon=${longitude}&lat=${latitude}`,
  };

  const urls = isMobile ? mobileUrls : webUrls;

  return (
    <div className="nav-links" onClick={handleClick}>
      <a href="#" onClick={handleNaverMapClick} rel="noopener noreferrer">
        <img src="/assets/navermap.png" alt="네이버맵 이동" />
        <span>네이버 지도</span>
      </a>
      <a href="#" onClick={handleKakaoNaviClick} rel="noopener noreferrer">
        <img src="/assets/kakaonavi.png" alt="카카오내비 이동" />
        <span>카카오내비</span>
      </a>
      <a
        href={urls.tmap}
        target={isMobile ? "_self" : "_blank"}
        rel="noopener noreferrer"
        onClick={handleTmapClick}
      >
        <img src="/assets/tmap.png" alt="T맵 이동" />
        <span>TMAP</span>
      </a>
    </div>
  );
};

export default NavigationLinks;
